import React, { useState } from 'react';
import './_style.scss';

const PasswordField = ({
    input,
    value,
    readOnly,
    isFocus,
    meta: { touched, error, warning },
    ...custome
}) => {
    const [showPassword, setShowPassword] = useState(false);

    const handleFocus = (e) => {
        if (isFocus) {
            e.target.select();
        }
    };

    const onClick = () => {
        setShowPassword((prevState) => !prevState);
    };

    return (
        <div className="form-group has-feedback has-feedback-left login-password-input">
            <div className="contain-error">
                <input
                    {...input}
                    {...custome}
                    onFocus={handleFocus}
                    readOnly={readOnly}
                    onChange={(e) => input.onChange(e)}
                    type={showPassword ? 'text' : 'password'}
                />
            </div>
            {touched &&
                ((error && <small>{error}</small>) ||
                    (warning && <small>{warning}</small>))}
            <div className="form-control-feedback">
                <i className="icon-lock2 text-primary" />
            </div>

            <div
                className="form-control-feedback right"
                onClick={onClick}
                role="button"
                tabIndex={-1}
            >
                <i
                    className={
                        showPassword
                            ? 'icon-eye text-primary'
                            : 'icon-eye-blocked'
                    }
                />
            </div>
        </div>
    );
};

export default PasswordField;
